import { ReparoApi } from '@api';
import { QueryKeys } from '@constants/queryKeys';
import {
    type ApiError,
    type ApiHealthResults,
    type HealthState,
} from '@diagon-alley/common';
import useQueryError from '@hooks/query/useQueryError';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

const getHealthState = async () =>
    ReparoApi<ApiHealthResults>({
        url: `/health`,
        method: 'GET',
        body: undefined,
    });

const useHealth = (
    useQueryOptions?: UseQueryOptions<HealthState, ApiError>,
) => {
    const setErrorResponse = useQueryError();

    const health = useQuery<HealthState, ApiError>({
        queryKey: [QueryKeys.HEALTH],
        queryFn: getHealthState,
        onError: (result) => {
            setErrorResponse(result);
        },
        ...useQueryOptions,
    });

    return health;
};

export default useHealth;
